// FALLBACK enduro tour prices. Compta is the source of truth: the live prices
// come from the get_variant_pricing RPC via useEnduroPricing (React surfaces)
// and the chatbot's mount-time fetch (which merges into this record in place).
// These values are only shown when compta is unreachable, so keep them equal
// to compta's products.base_price_usd (source_id 85022749, variants
// half_day/full_day/2_day/6_day). enduroPricing.test.ts pins them.
//
// Every place that needs an enduro tour price MUST go through useEnduroPricing
// (or this record for non-React code) — do NOT re-hardcode the numbers.
// Record<string, number> (not the narrow union) so callers can index with a
// `string` variant (e.g. state.tourType) without a cast — matches prior usage.
export const ENDURO_TOUR_PRICES_USD: Record<string, number> = {
  half_day: 100,
  full_day: 150,
  '2_day': 240, // unchanged — confirm with compta if 2-day also rose
  '6_day': 990, // Xaysomboun Enduro Camp — 6-day expedition, accommodation included (compta base_price_usd)
}

export const ENDURO_TOUR_LABELS: Record<string, string> = {
  half_day: 'Half Day',
  full_day: 'Full Day',
  '2_day': '2 Days',
  '6_day': '6 Days — Xaysomboun Camp',
}

// Canonical display order for enduro tour variants (shortest → longest). The
// chatbot's tour_type option list is generated in this order regardless of the
// row order returned by the `tours` table, so a newly activated tour always
// slots into the right place. Keep in sync with the variant keys above.
export const ENDURO_VARIANT_ORDER: string[] = [
  'half_day',
  'full_day',
  '2_day',
  '6_day',
]

// Emoji prefix per variant for the chatbot option labels. Mirrors the static
// labels in chatbotConfig (steps.tour_type) so the generated list looks
// identical to today's hardcoded one.
export const ENDURO_TOUR_EMOJI: Record<string, string> = {
  half_day: '⏱️',
  full_day: '🌄',
  '2_day': '🏕️',
  '6_day': '🏔️',
}
